import './modal-footer.scss';

function ModalFooter({...props}) {
    return (
        <div className="modal-footer">
            {props.children}
        </div>
    )
}

export default ModalFooter;